export default __webpack_public_path__ + "static/media/linkedin.32eb7a53.png";